import Konva from "konva";

import { DMCWeather } from "../KObjects/DMCWeather";
import { GeneratedWeather } from "../Generator/GeneratedWeather.js";

function toInt(i) {
  const parsed = parseInt(i, 10);
  if (isNaN(parsed)) {
    return 0;
  }
  return parsed;
}

export class Weather {
  constructor() {
    this.layer = {};
    this.currentObject = null;
    this.currentShapeConfig = {};
    this.mouseDownProgress = false;
    this.interval = false;
    this.origin = {};
    this.currentController = [];
    this.name = "Weather";
    (this.type = "widget"),
      (this.currentOptions = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        scaleX: 0,
        scaleY: 0,
      });
    this.dataWeather = {};
    this.weatherItem = new GeneratedWeather();
  }

  weather(dataWeather, name) {
    this.name = name;
    this.dataWeather = dataWeather;
  }

  createControllerObject(name, konvaObject) {
    return new DMCWeather(name, konvaObject, this.dataWeather);
  }

  createNew(controllerProject, incorporate = true) {
    return new Promise((resolve, reject) => {
      this.currentController = controllerProject;

      this.weatherItem.initVal(this.dataWeather.fullParams).then(() => {
        this.weatherItem
          .getWeather(this.dataWeather)
          .then(() => {
            this.dataWeather.group = this.weatherItem.changParams();

            const rect = new Konva.Rect({
              name: "textWeather",
              x: 0,
              y: 0,
              width: this.dataWeather.group.getClientRect({
                skipTransform: true,
              }).width,
              height: this.dataWeather.group.getClientRect({
                skipTransform: true,
              }).height,
            });

            this.dataWeather.group.add(rect);
            this.dataWeather.font = this.dataWeather.fullParams.font;
            this.dataWeather.nbDay = this.dataWeather.fullParams.nbDay;
            this.currentObject = this.dataWeather.group;

            if (incorporate) {
              this.layer = controllerProject.addElementToCurrentLayerReturn(this.currentObject);
            }
            return resolve();
          })
          .catch((err) => {
            return reject(err);
          });
      });
    });
  }

  loadSpec(controllerProject, DMCObject, incorporate) {
    return new Promise((resolve, reject) => {
      this.createNew(controllerProject, incorporate)
        .then(() => {
          this.currentObject.setAttr("x", toInt(DMCObject.konvaObjectOption.x));
          this.currentObject.setAttr("y", toInt(DMCObject.konvaObjectOption.y));
          this.currentObject.setAttr("width", toInt(DMCObject.konvaObjectOption.width));
          this.currentObject.setAttr("height", toInt(DMCObject.konvaObjectOption.height));
          this.currentObject.setAttr("scaleX", parseFloat(DMCObject.konvaObjectOption.scaleX));
          this.currentObject.setAttr("scaleY", parseFloat(DMCObject.konvaObjectOption.scaleY));
          this.currentObject.id(DMCObject.konvaObjectOption.id);
          this.updateCurrentOptions(
            this.currentObject.getAttr("x"),
            this.currentObject.getAttr("y"),
            this.currentObject.getAttr("width"),
            this.currentObject.getAttr("height")
          );

          if (incorporate) {
            this.layer = controllerProject.addElementToCurrentLayerReturn(this.currentObject);
          }

          return resolve(this.currentObject);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  mouseUp(controllerProject) {
    if (this.currentObject && !this.mouseDownProgress) {
      clearInterval(this.interval);
      this.interval = false;
      controllerProject.destroyAllTransformer();
      controllerProject.currentSelection = this.createTransformer(this.currentObject);

      controllerProject.addElementToCurrentLayer(controllerProject.currentSelection);
      const name = controllerProject.addNewObjectToCurrentLayer(this.currentObject, this.name, this);

      // We finalize widget position on mouseUp
      const currentMousePos = controllerProject.collectCurrentMousePosition();
      const sceneScale = controllerProject.scale;

      this.updateCurrentObject(currentMousePos, sceneScale);
      this.updateCurrentOptions(
        this.currentObject.getAttr("x"),
        this.currentObject.getAttr("y"),
        this.currentObject.getAttr("width"),
        this.currentObject.getAttr("height")
      );

      try {
        controllerProject.stage.draw();
      } catch (err) {
        console.error(err);
      }

      this.currentOptions = this.resetOptions();
      return name;
    } else {
      return null;
    }
  }

  mouseDown(controllerProject) {
    this.mouseDownProgress = true;
    this.dataWeather.scale = controllerProject.scale;
    this.currentController = controllerProject;
    this.createNew(controllerProject)
      .then(() => {
        // WE CAN MOVE THE WIDGET AT THE CORRECT PLACE BEFORE MOUSEUP
        if (!this.interval) {
          this.interval = setInterval(() => {
            const currentMousePos = controllerProject.collectCurrentMousePosition();
            const sceneScale = controllerProject.scale;

            this.updateCurrentObject(currentMousePos, sceneScale);
            this.updateCurrentOptions(
              this.currentObject.getAttr("x"),
              this.currentObject.getAttr("y"),
              this.currentObject.getAttr("width"),
              this.currentObject.getAttr("height")
            );
          }, 50);
        }
      })
      .finally(() => {
        this.mouseDownProgress = false;
      });
  }

  createTransformer(elementToTransform) {
    return new Konva.Transformer({
      enabledAnchors: [
        "top-left",
        "top-center",
        "top-right",
        "middle-right",
        "middle-left",
        "bottom-center",
        "bottom-left",
        "bottom-right",
      ],
      keepRatio: true,
      node: elementToTransform,
    });
  }

  updateCurrentObject(currentMousePos, scale) {
    this.currentObject.setAttr(
      "x",
      Math.round(currentMousePos.x / scale - this.currentObject.getClientRect({ skipTransform: true }).width / 2)
    );
    this.currentObject.setAttr(
      "y",
      Math.round(currentMousePos.y / scale - this.currentObject.getClientRect({ skipTransform: true }).height / 2)
    );
    this.currentObject.setAttr("width", this.currentObject.getClientRect({ skipTransform: true }).width);
    this.currentObject.setAttr("height", this.currentObject.getClientRect({ skipTransform: true }).height);
    this.currentObject.setAttr("fontSize", this.dataWeather.size);
  }

  updateCurrentOptions(x, y, width, height) {
    this.currentOptions.x = toInt(x);
    this.currentOptions.y = toInt(y);
    this.currentOptions.width = toInt(width);
    this.currentOptions.height = toInt(height);
  }

  resetOptions() {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      scaleX: 0,
      scaleY: 0,
    };
  }

  setContent(dataWeather, name) {
    this.weather(dataWeather, name);
  }

  setConfig(edit) {
    this.edit = edit;
  }

  editNewElement(controllerProject) {
    this.createNew(controllerProject)
      .then(() => {
        this.currentObject.setAttr("x", toInt(this.edit.x));
        this.currentObject.setAttr("y", toInt(this.edit.y));
        this.currentObject.setAttr("width", toInt(this.edit.width));
        this.currentObject.setAttr("height", toInt(this.edit.height));
        this.currentObject.setAttr("scaleX", parseFloat(this.edit.scaleX));
        this.currentObject.setAttr("scaleY", parseFloat(this.edit.scaleY));
        this.edit = "";
        return this.mouseUp(controllerProject);
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
